import postAPI from './postAPI.js'

export default async function postGetConditionSources(taskFlowId, currentStepId = null, includeSelf = false) {
    const body = { task_flow_id: taskFlowId };
    if (currentStepId) {
        body.current_step_id = currentStepId;
    }
    if (includeSelf) {
        body.include_self = true;
    }
    const data = await postAPI('admin/taskflows/steps/conditions/sources', body);
    return data;
}
